export default class Tabs extends Component {
  render() {
    const { items, names, activeIndex } = this.props
    const highlightColor = `rgba(0, 0, 0, 0.3)`
    const width = 205

    return (
      <Surface
        flexFlow="row"
        overflow="hidden"
        position="relative"
        height={40}
        paddingLeft={40}
        marginLeft={-40}
        transform="translateX(-20px)"
        // style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}
      >
        {items.map((item, index) => {
          const active = activeIndex === index
          return (
            <Surface
              marginX={-10}
              className="tab"
              zIndex={1000}
              style={{
                position: "absolute",
                alignItems: "center",
                left: 50 + index * (width - 30),
                width: width,
                zIndex: active ? 1000 : 100 - index,
                borderTopRightRadius: "25px 170px",
                height: 170,
                borderTopLeftRadius: "20px 80px",
                padding: "4px 10px 0px 10px",
                background: active ? "white" : "rgba(246,249,252,1)",
                boxShadow: "0 10px 20px rgba(0,0,0,.08)",
                border: `1px solid ${
                  active ? highlightColor : `rgba(0, 0, 0, 0.1)`
                }`,
                cursor: "pointer",
              }}
            >
              {item}
            </Surface>
          )
        })}
      </Surface>
    )
  }
}
